<accordion>
    <accordion-panel>
        <div panel-header>Type of PDF Document</div>
        <div class="grid-x">
            <div class="cell small-12">
                <label for="pdfSelector">Select Type of Document to Generate:</label>
            </div>
            <div class="cell small-12">
                <select id="pdfSelector" [(ngModel)]="pdfType" (ngModelChange)="pdfTypeChanged($event)">
                    <option value=" ">-- Select --</option>
                    <option value="PermitToDrill">Permit to Drill a Well</option>
                    <option value="PermitToPlug">Permit to Plug and Abandon</option>
                    <option value="FAReturn">Financial Assurance Return Data</option>
                    <option value="Context">Get Type From Context</option>
                </select>
            </div>
            <ng-container [ngSwitch]="pdfType">
                <ng-container *ngSwitchCase="'Context'">
                    <div class="cell small-4">
                        Context Location:
                    </div>
                    <div class="cell small-8">
                        <input type="text" [(ngModel)]="pdfTypeContext" />
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="'FAReturn'">
                    <div class="cell small-12 bold">
                        Context Locations for Necessary Data
                    </div>
                    <div class="cell small-12">
                        Source Application Type:
                    </div>
                    <div class="cell small-12">
                        <input type="text" [(ngModel)]="sourceApplicationType" />
                    </div>
                    <div class="cell small-12">
                        Returned to Owner Date:
                    </div>
                    <div class="cell small-12">
                        <input type="text" [(ngModel)]="returnToOwnerDate" />
                    </div>
                    <div class="cell small-12">
                        Bond / Check Number:
                    </div>
                    <div class="cell small-12">
                        <input type="text" [(ngModel)]="bondNumber" />
                    </div>
                    <div class="cell small-12">
                        Bond Release Date:
                    </div>
                    <div class="cell small-12">
                        <input type="text" [(ngModel)]="bondReleaseDate" />
                    </div>
                    <div class="cell small-12">
                        Type of Bond Released:
                    </div>
                    <div class="cell small-12">
                        <input type="text" [(ngModel)]="bondTypeReleased" />
                    </div>
                    <ng-template dynamic-component-loader
                                 [componentName]="'multiselectdataconfig'"
                                 [componentData]="bondTypeDomain"
                                 [componentContext]="componentContext"
                                 [isEdit]="true">
                    </ng-template>
                </ng-container>                   
                <ng-container *ngSwitchDefault>
                    <div class="cell small-12">
                        &nbsp;
                    </div>
                </ng-container>                
            </ng-container>   
			<ng-container *ngIf="pdfType !== 'FAReturn'">
				<div class="cell small-4">
					Permit Data Context:
				</div>
				<div class="cell small-8">
					<input type="text" [(ngModel)]="permitDataContext" />
				</div>
				<div class="cell small-4">
					Well Data Context:
				</div>
				<div class="cell small-8">
					<input type="text" [(ngModel)]="wellDataContext" />
				</div>
				<div class="cell small-4">
					Contact Data Context:
				</div>
				<div class="cell small-8">
					<input type="text" [(ngModel)]="contactDataContext" />
				</div>
				<div class="cell small-4">
					Organization Id Context:
				</div>
				<div class="cell small-8">
					<input type="text" [(ngModel)]="organizationIdLocation" />
				</div>
			</ng-container>
        </div>
    </accordion-panel>
    <accordion-panel>
        <div panel-header>PDF Options</div>
        <div class="grid-x">
            <div class="cell small-12">
                PDF Generation Options:
            </div>
            <div class="cell small-12 checkbox">
                <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" id="useDefaults" [(ngModel)]="componentData.config.pdfOptions.useDefaults" />
                <label for="useDefaults">
                    <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
                    Use default PDF generation options
                </label>
            </div>
            <ng-container *ngIf="!componentData.config.pdfOptions.useDefaults">
                <div class="grid-x">
                    <div class="cell small-12 checkbox">
                        <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" id="landscape" [(ngModel)]="componentData.config.pdfOptions.landscape" />
                        <label for="landscape">
                            <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
                            Print Landscape
                        </label>
                    </div>
                    <div class="cell small-4 text-align-leftt padding-right-small">
                        Paper Type:
                    </div>
                    <div class="cell small-8">
                        <select [(ngModel)]="componentData.config.pdfOptions.paperFormat">
                            <option value="letter">Letter</option>
                            <option value="legal">Legal</option>
                        </select>
                    </div>
                </div>
                <div class="grid-x">
                    <div class="cell small-12">
                        Margin Options:
                    </div>
                    <div class="cell small-4 text-align-right">
                        Top (pixels):
                    </div>
                    <div class="cell small-8">
                        <input type="number" [(ngModel)]="componentData.config.pdfOptions.marginOptions.top" />
                    </div>
                    <div class="cell small-4 text-align-right">
                        Bottom (pixels):
                    </div>
                    <div class="cell small-8">
                        <input type="number" [(ngModel)]="componentData.config.pdfOptions.marginOptions.bottom" />
                    </div>
                    <div class="cell small-4 text-align-right">
                        Left (pixels):
                    </div>
                    <div class="cell small-8">
                        <input type="number" [(ngModel)]="componentData.config.pdfOptions.marginOptions.left" />
                    </div>
                    <div class="cell small-4 text-align-right">
                        Right (pixels):
                    </div>
                    <div class="cell small-8">
                        <input type="number" [(ngModel)]="componentData.config.pdfOptions.marginOptions.right" />
                    </div>
                </div>
            </ng-container>
            <div class="cell small-12 checkbox">
                <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" id="mergeDocuments" [(ngModel)]="mergeDocuments" />
                <label for="mergeDocuments">
                    <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
                    Merge other documents in flow into single PDF on document save
                </label>
            </div>
            <ng-container *ngIf="mergeDocuments">
                <div class="cell small-12 checkbox">
                    <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" id="customHeader" [(ngModel)]="useCustomHeader" />
                    <label for="customHeader">
                        <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
                        Apply Custom Header to Merged Documents
                    </label>
                </div>
                <ng-container *ngIf="useCustomHeader">
                    <div class="cell small-12 checkbox">
                        <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" id="useExpression" [(ngModel)]="compileAsExpression" />
                        <label for="useExpression">
                            <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
                            Compile Custom Header as Expression
                        </label>
                    </div>
                    <ng-container *ngIf="compileAsExpression">
                        <div class="cell small-12">
                            Expression for Generating Header:
                        </div>
                        <div class="cell small-12">
                            <rules-editor [(expression)]="componentData.config.pdfOptions.customHeader.headerText" [placeholder]="'Expression to Generate Document Header'" (updateRule)="ruleCompiled($event)"></rules-editor>
                        </div>
                        <ng-container *ngIf="componentData.config.pdfOptions.customHeader.expressionRule === undefined">
                            <div class="cell small-12 bold red">
                                Header will not be able to be inserted until an expression has been successfully compiled!
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="!compileAsExpression">
                        <div class="cell small-12">
                            Text of Custom Header:
                        </div>
                        <div class="cell small=12">
                            <input type="text" [(ngModel)]="componentData.config.pdfOptions.customHeader.headerText" />
                        </div>
                    </ng-container>
                </ng-container>
                <div class="cell small-12 checkbox">
                    <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" id="staticDocuments" [(ngModel)]="addStaticDocuments" />
                    <label for="staticDocuments">
                        <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
                        Attach Static Documents to Every Generated PDF
                    </label>
                </div>
                <ng-container *ngIf="addStaticDocuments">
                    <div class="cell small-12 checkbox">
                        <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" id="addFirst" [(ngModel)]="appendStaticDocumentsFirst" />
                        <label for="addFirst">
                            <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
                            Append Static Documents First
                        </label>
                    </div>
                    <div class="cell small-12">
                        Files Currently being attached to the generated document:
                    </div>
                    <div class="cell small-12">
                        <ul *ngFor="let file of componentData.config.pdfOptions.staticFiles">
                            <li>
                                {{file.fileName}} <button (click)="deleteFile(file)"><svg-icon class="small medium-gray" icon="icon-trash"></svg-icon></button>
                            </li>
                        </ul>
                        <ng-container *ngIf="componentData.config.pdfOptions.staticFiles.length === 0">
                            No files currently uploaded.
                        </ng-container>
                    </div>
                    <div class="cell small-12">
                        Select an existing file to attach to the document:
                    </div>
                    <div class="cell small-10 padding-right-small">
                        <select *ngIf="attachments$" id="attachmentSelector" class="margin-bottom-large" [(ngModel)]="selectedAttachment" >
                            <option *ngFor="let a of attachments$ | async" [ngValue]="a">{{a.fileName}}</option>
                        </select>
                        <p *ngIf="!attachments$">Loading available attachments...</p>
                    </div>
                    <div class="cell small-2">
                        <button class="button" (click)="addFileToConfig()">Add</button>
                    </div>
                    <div class="cell small-12">
                        Upload new file(s) to be attached to every generated document:
                    </div>
                    <div class="cell small-12">
                        <input type="file" #input id="file" name="file" class="file-select" multiple (change)="addFile($event)" />
                    </div>
                    <div class="cell small-12">
                        Saved files to be uploaded to every document:
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </accordion-panel>
    
    <accordion-panel>
        <div panel-header>OnBase Configuration</div>
        <ng-template dynamic-component-loader
                     [componentName]="'fileuploaddataconfig'"
                     [componentData]="componentData">
        </ng-template>
      
    </accordion-panel>
</accordion>
<ng-template #notApplicable>
    <div class="cell small-12">
        &nbsp;
    </div>
</ng-template>